var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import GenericSidebar from "@frameworks/shared-library/components/GenericSidebar";
import profileicon from "@frameworks/shared-library/assets/images/salesjourney/profile/profile-icon.svg";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import InputField from "@frameworks/web/components/generic/inputField";
import GenericTooltip from "../../../../../shared-library/components/GenericTooltip";
import di from "../di/serviceLocator";
import { getImageString } from "@frameworks/salesjourney/utils/genericMethods";
import { onlyNumbersNotAllowed } from "@frameworks/salesjourney/utils/regex";
import EdModal from "@frameworks/web/components/generic/edModal";
import ProfileCard from "./ProfileCard";
import loginDI from "@frameworks/salesjourney/components/Login/di/index";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
export var sociallinks = function (props, setSocialData, intSocialData) {
    var _a = __read(useState(), 2), linkedInError = _a[0], setLinkedInError = _a[1];
    var _b = __read(useState(), 2), facebookError = _b[0], setFacebookError = _b[1];
    var _c = __read(useState(), 2), twitterError = _c[0], setTwitterError = _c[1];
    return (React.createElement(React.Fragment, null,
        React.createElement("div", null,
            React.createElement(Row, { className: "mx-0 socaillinkrow" },
                React.createElement("div", null,
                    React.createElement("label", null, "Linkedin")),
                React.createElement(InputField, { type: "text", id: "email", name: "email", pattern: onlyNumbersNotAllowed, autoComplete: "off", placeholderClassName: "", defaultValue: intSocialData === null || intSocialData === void 0 ? void 0 : intSocialData.linkedin, onChange: function (e) {
                        setSocialData(__assign(__assign({}, intSocialData), { linkedin: e }));
                        setLinkedInError("");
                    }, onBlur: function (e) {
                        if (!e.pattern && (intSocialData === null || intSocialData === void 0 ? void 0 : intSocialData.linkedin) != "")
                            setLinkedInError("Only numbers not allowed");
                    }, errorText: linkedInError })),
            React.createElement(Row, { className: "mx-0 socaillinkrow" },
                React.createElement("div", null,
                    React.createElement("label", null, "FB")),
                React.createElement(InputField, { type: "text", id: "facebook", name: "facebook", pattern: onlyNumbersNotAllowed, autoComplete: "off", placeholderClassName: "", defaultValue: intSocialData === null || intSocialData === void 0 ? void 0 : intSocialData.facebook, onChange: function (e) {
                        setSocialData(__assign(__assign({}, intSocialData), { facebook: e }));
                        setFacebookError("");
                    }, onBlur: function (e) {
                        if (!e.pattern && (intSocialData === null || intSocialData === void 0 ? void 0 : intSocialData.facebook) != "")
                            setFacebookError("Only numbers not allowed");
                    }, errorText: facebookError })),
            React.createElement(Row, { className: "mx-0 socaillinkrow" },
                React.createElement("div", null,
                    React.createElement("label", null, "Twitter")),
                React.createElement(InputField, { type: "text", id: "twitter", name: "twitter", pattern: onlyNumbersNotAllowed, autoComplete: "off", placeholderClassName: "", defaultValue: intSocialData === null || intSocialData === void 0 ? void 0 : intSocialData.twitter, onChange: function (e) {
                        setSocialData(__assign(__assign({}, intSocialData), { twitter: e }));
                        setTwitterError("");
                    }, onBlur: function (e) {
                        if (!e.pattern && (intSocialData === null || intSocialData === void 0 ? void 0 : intSocialData.twitter) != "")
                            setTwitterError("Only numbers not allowed");
                    }, errorText: twitterError })))));
};
export var Profileinfo = function (props) {
    var device = DeviceContext();
    var _a = __read(React.useState({
        linkedin: props.linkedIn,
        facebook: props.fB,
        twitter: props.twitter,
    }), 2), intSocialData = _a[0], setSocialData = _a[1];
    var _b = __read(React.useState(false), 2), openicon = _b[0], setOpenicon = _b[1];
    var _c = __read(useState(false), 2), emailIcon = _c[0], setEmailicon = _c[1];
    var _d = __read(useState(), 2), file = _d[0], setFile = _d[1];
    var _e = __read(useState(false), 2), changeImage = _e[0], setChangeImage = _e[1];
    var _f = __read(React.useState(true), 2), isImageValid = _f[0], setIsImageValid = _f[1];
    var _g = __read(React.useState(false), 2), socialPostSuccess = _g[0], setSocialPostSuccess = _g[1];
    var _h = __read(React.useState({
        linkedin: false,
        facebook: false,
        twitter: false,
    }), 2), clickOnSocial = _h[0], setClickOnSocial = _h[1];
    var socialMediaDetails = function () {
        di.profile.getSocialMediaDetails().then(function (resp) {
            if (resp) {
                setSocialData(function (prevState) { return (__assign(__assign({}, prevState), { facebook: (resp === null || resp === void 0 ? void 0 : resp.facebook) ? resp.facebook : "", linkedin: (resp === null || resp === void 0 ? void 0 : resp.linkedin) ? resp.linkedin : "", twitter: (resp === null || resp === void 0 ? void 0 : resp.twitter) ? resp.twitter : "" })); });
            }
            else {
                setSocialData({
                    linkedin: "",
                    facebook: "",
                    twitter: "",
                });
            }
        });
    };
    var getProfilImage = function () { return __awaiter(void 0, void 0, void 0, function () {
        var profileImage;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, di.profile.getProfileImage()];
                case 1:
                    profileImage = _a.sent();
                    if (profileImage) {
                        setFile(getImageString(profileImage));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var onSelectFile = function (e) {
        var selectedFiles = e.target.files;
        if (selectedFiles === null || selectedFiles === void 0 ? void 0 : selectedFiles[0]) {
            setFile(URL.createObjectURL(selectedFiles === null || selectedFiles === void 0 ? void 0 : selectedFiles[0]));
            var fileTypes = ["jpg", "jpeg", "png"];
            var file1_1 = selectedFiles[0];
            var fileType = fileTypes.find(function (val) { return file1_1.type.split("/")[1] === val; });
            var fileSize = file1_1.size;
            if (fileSize <= 5242880) {
                if (fileTypes.includes(fileType)) {
                    setIsImageValid(true);
                    var reader_1 = new FileReader();
                    reader_1.readAsDataURL(selectedFiles[0]);
                    reader_1.onload = function () { return __awaiter(void 0, void 0, void 0, function () {
                        var base64Image, profileImageResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    base64Image = reader_1.result;
                                    return [4 /*yield*/, di.profile.postProfileImage({
                                            imagestring: base64Image.split(",")[1],
                                        })];
                                case 1:
                                    profileImageResponse = _a.sent();
                                    if (profileImageResponse) {
                                        getProfilImage();
                                        // alert("Image saved sucessfully");
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    }); };
                }
                else {
                    setIsImageValid(false);
                    alert("Invalid image,Please select jpg,jpeg,png type image. !!!");
                }
            }
            else {
                getProfilImage();
                setIsImageValid(false);
                return alert("Image size should be less that 5MB. !!!!");
            }
        }
    };
    var postSocialData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var socialMediaResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, di.profile.updateSocailMedia(intSocialData)];
                case 1:
                    socialMediaResponse = _a.sent();
                    if (socialMediaResponse) {
                        setSocialPostSuccess(true);
                        setClickOnSocial({
                            facebook: false,
                            twitter: false,
                            linkedin: false,
                        });
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    React.useEffect(function () {
        getProfilImage();
        validateSocial();
    }, []);
    var validateSocial = function () {
        if (!(intSocialData === null || intSocialData === void 0 ? void 0 : intSocialData.linkedin) &&
            !(intSocialData === null || intSocialData === void 0 ? void 0 : intSocialData.facebook) &&
            !(intSocialData === null || intSocialData === void 0 ? void 0 : intSocialData.twitter))
            return true;
        else
            return false;
    };
    React.useEffect(function () {
        return function () { return setSocialPostSuccess(false); };
    }, [openicon]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "profile-info-container" },
            React.createElement("div", { className: "profile-title DMSan_28_700 txt-midnight-blue " }, "Profile"),
            React.createElement("div", { className: "d-flex container-box" },
                React.createElement("div", { className: "profile-image-container" },
                    React.createElement("label", { id: "image-label", onMouseEnter: function () { return setChangeImage(true); }, onMouseLeave: function () { return setChangeImage(false); }, className: changeImage &&
                            "label-hover d-flex align-items-center justify-content-center" },
                        React.createElement("label", { onClick: function (e) {
                                onSelectFile(e);
                            }, className: "text-decoration-underline DMSanM_14_500 txt-midnight-blue hand_cursor profile-upload", htmlFor: "feedBackFile" },
                            file ? "Change" : "Add Image",
                            React.createElement("input", { type: "file", id: "feedBackFile", onChange: onSelectFile, hidden: true })),
                        React.createElement("img", { alt: "", className: "profile-img hand_cursor", src: file ? file : profileicon }))),
                React.createElement("div", null,
                    React.createElement("div", { className: "DMSan_24_700 txt-midnight-blue px-0 d-flex profile-name-block" }, props === null || props === void 0 ? void 0 :
                        props.profilename,
                        " ",
                        React.createElement("span", { className: "txt_blue-tint" },
                            React.createElement(GenericTooltip, { placement: "top", button: React.createElement("i", { className: "edel-icon-linkedin ".concat(clickOnSocial.linkedin && "txt-tomato"), onClick: function () {
                                        socialMediaDetails();
                                        setOpenicon(!openicon);
                                        setClickOnSocial(__assign(__assign({}, clickOnSocial), { linkedin: true }));
                                    } }), toolTipText: "LinkedIn", triggerType: "hover", noButton: true, toolTipClassName: "profile-tooltips" })),
                        React.createElement("span", { className: "txt_blue-tint" },
                            React.createElement(GenericTooltip, { placement: "top", button: React.createElement("i", { className: "edel-icon-facebook ".concat(clickOnSocial.facebook && "txt-tomato"), onClick: function () {
                                        socialMediaDetails();
                                        setOpenicon(!openicon);
                                        setClickOnSocial(__assign(__assign({}, clickOnSocial), { facebook: true }));
                                    } }), toolTipText: "Facebook", triggerType: "hover", noButton: true, toolTipClassName: "profile-tooltips" })),
                        React.createElement("span", { className: "txt_blue-tint" },
                            React.createElement(GenericTooltip, { placement: "top", button: React.createElement("i", { className: "edel-icon-twitter-new ".concat(clickOnSocial.twitter && "txt-tomato"), onClick: function () {
                                        socialMediaDetails();
                                        setOpenicon(!openicon);
                                        setClickOnSocial(__assign(__assign({}, clickOnSocial), { twitter: true }));
                                    } }), toolTipText: "Twitter", triggerType: "hover", noButton: true, toolTipClassName: "profile-tooltips" })),
                        " "),
                    (loginDI === null || loginDI === void 0 ? void 0 : loginDI.login.getIsRMPartnerFRM().isPartner) && (React.createElement("div", { className: "DMSan_16_700 txt_primaryGrey" }, props === null || props === void 0 ? void 0 : props.agreementTypeName)),
                    React.createElement("div", { className: "DMSan_16_700 txt_primaryGrey address-block" }, props.address)))),
        React.createElement(Row, { className: "profile-details-data" }, props.data.map(function (item) {
            return (React.createElement(React.Fragment, null,
                React.createElement(Col, { lg: 3, className: "profile-details-data-tile" },
                    React.createElement("div", { className: "mbt-5" }, item.title),
                    React.createElement("div", { className: "value ellipsis" },
                        React.createElement("span", { title: item.value }, item.value)))));
        })),
        (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement(GenericSidebar, { delay: 10, parentClassname: "profile-socialicons-block", header: React.createElement(Row, { className: "m-0" },
                React.createElement("label", { className: "DMSans_16_500 txt_blackOne1 sociallinkslabel" }, "Add Social Links")), body: React.createElement("div", { className: "DMSanN_16_400 txt_blackOne1 content-body" },
                sociallinks(props, setSocialData, intSocialData),
                socialPostSuccess && (React.createElement("div", { className: "DMSanN_14_400 bg_pastel-cream  d-flex justify-content-center m-4 p-3" }, "Data saved successfully."))), footer: React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Save & Update", disabled: validateSocial(), onClick: function () {
                    //getImageData();
                    postSocialData();
                } }), openKey: openicon, setOpenKey: setOpenicon, arrowClose: true, onSideBarClose: function () {
                return setClickOnSocial({
                    facebook: false,
                    twitter: false,
                    linkedin: false,
                });
            } })) : (""),
        React.createElement(EdModal, { show: emailIcon, setShow: setEmailicon, showFooter: false, size: "modal-md modal-dialog-centered", children: React.createElement(React.Fragment, null,
                React.createElement("div", null,
                    React.createElement(ProfileCard, { name: "Smit Sharma", destination: "Relationship Manager- Digital", email: "smit.sharma@nuvama.com", phoneNo: "+91 9920603456" })),
                React.createElement("div", { className: "email-arrow-sent-block px-5" },
                    React.createElement("div", { className: "emailarrow ".concat("emailarrow-disabled") },
                        React.createElement("i", { className: "edel-icon-emailsentarrow" })),
                    React.createElement("div", { className: "w-100 email-arrow-input" },
                        React.createElement(InputField, { name: "email", id: "email", type: "email", className: "RobotoM_16_500 txt_blackOne1", placeholderClassName: "", placeholder: "Enter an Email Id you want to Send to", required: true })))), title: "Share my Card", modalTitle: "sharemy-card-block" })));
};
